function escapeHtml(str) {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function isRepeatingFile(file, filesToSendGroup) {
  return filesToSendGroup.some(
    (item) =>
      item.name === file.name && item.lastModified === file.lastModified,
  );
}

// Keeps the native file input in sync with the accumulated file list
// so that new FormData(form) correctly picks up all intended files
function syncInputFiles(inputElement, files) {
  const dt = new DataTransfer();
  files.forEach((f) => dt.items.add(f));
  inputElement.files = dt.files;
}

function handleFile(file, uploadElement, state) {
  if (isRepeatingFile(file, state.filesToSendGroup)) {
    return;
  }

  // Implemented extension checking, not MIME TYPE, because browsers often do not determine the true file type
  const fileExtension = file.name.split(".").pop();
  const isTypeTrue = state.trueExtensions.includes(fileExtension);

  state.allFilesSize += file.size;

  if (
    !isTypeTrue ||
    file.size > state.maxSizeFiles ||
    state.filesToSendGroup.length >= state.maxQtyFiles ||
    state.allFilesSize > state.maxSizeFiles
  ) {
    const formField = uploadElement.closest(".js-form_field");
    formField.classList.add("m-invalid");
    state.allFilesSize -= file.size;
    return;
  }

  const template = `
    <div class="b-attach_files-file">
      <p class="b-attach_files-file_name">${escapeHtml(file.name)}</p>
      <button type="button" data-index="${state.countFiles}" data-filesize="${file.size}" class="b-attach_files-file_remove js-file_upload_remove">&times;</button>
    </div>
  `;

  const fileUploadList = uploadElement.querySelector(".js-file_upload_list");
  fileUploadList.insertAdjacentHTML("beforeend", template);

  uploadElement.classList.add("loaded");

  file.key = state.countFiles;
  state.filesToSendGroup.push(file);
  state.countFiles++;

  state.filesToSend[state.groupName] = state.filesToSendGroup;
}

export default function initFileUpload() {
  const uploadElements = document.querySelectorAll(".js-file_upload");

  if (!uploadElements.length) {
    return;
  }

  uploadElements.forEach((uploadElement) => {
    if (uploadElement.dataset.uploadInitialized) {
      return;
    }
    uploadElement.dataset.uploadInitialized = "true";

    const inputElement = uploadElement.querySelector(".js-file_upload_input");

    if (!inputElement) {
      return;
    }

    // Per-element state — prevents cross-contamination between multiple upload widgets
    const state = {
      trueExtensions: inputElement
        .getAttribute("accept")
        .split(",")
        .map((ext) => ext.replace(".", "").trim()),
      maxQtyFiles: parseInt(inputElement.dataset.maxQuantity) || 20,
      maxSizeFiles: parseInt(inputElement.dataset.maxFileSize) || 26214400,
      allFilesSize: 0,
      countFiles: 0,
      groupName: "",
      filesToSend: {},
      filesToSendGroup: [],
    };

    inputElement.addEventListener("change", () => {
      state.groupName = inputElement.getAttribute("name");
      state.filesToSendGroup = state.filesToSend[state.groupName] || [];

      Array.from(inputElement.files).forEach((file) =>
        handleFile(file, uploadElement, state),
      );

      // Sync native input with the full accumulated list so FormData picks up all files
      syncInputFiles(inputElement, state.filesToSendGroup);
    });

    uploadElement.addEventListener("click", function (e) {
      const removeBtn = e.target.closest(".js-file_upload_remove");
      if (!removeBtn || !this.contains(removeBtn)) return;

      const fileIndex = parseInt(removeBtn.dataset.index, 10);
      const filesize = parseInt(removeBtn.dataset.filesize, 10);
      let groupName = "";
      let currentIndex = -1;

      removeBtn.parentElement.remove();
      state.allFilesSize -= filesize;

      for (const filesGroup in state.filesToSend) {
        const idx = state.filesToSend[filesGroup].findIndex(
          (item) => item.key === fileIndex,
        );

        if (idx !== -1) {
          groupName = filesGroup;
          currentIndex = idx;
          break;
        }
      }

      if (groupName && currentIndex !== -1) {
        state.filesToSend[groupName].splice(currentIndex, 1);
      }

      const remainingFiles = state.filesToSend[groupName] || [];

      if (remainingFiles.length === 0) {
        uploadElement.classList.remove("loaded");
      }

      // Sync native input so removed file is excluded from FormData on submission
      syncInputFiles(inputElement, remainingFiles);
    });

    const form = uploadElement.closest("form");
    if (form) {
      form.addEventListener("reset", () => {
        state.filesToSend = {};
        state.filesToSendGroup = [];
        state.allFilesSize = 0;
        state.countFiles = 0;
        state.groupName = "";
        uploadElement.querySelector(".js-file_upload_list").innerHTML = "";
        uploadElement.classList.remove("loaded");
      });
    }
  });
}
